export const QUOTE_BUILDER_SLICE_NAME = 'quoteBuilder';

export const QUOTE_BUILDER_PART_INSIGHTS_SLICE_NAME =
  'quoteBuilderPartInsights';
